import { queryStringFromChannelObject } from '../constants/channels';

export default (channelObject) => {
  const newChannelString = queryStringFromChannelObject(channelObject);
  const channelString = newChannelString ? `?channel=${newChannelString}` : '';

  return `/${channelString}`;
};
